<template>
  <div class="time">
    <div class="notime"> {{ nowday }} {{ nowWeek }}{{ nowTime }}</div>
    
    </div>
</template>
<script>
export default {
  name: "theNowTime",
  components: {},
  props: {},
  data() {
    return {
      nowTime: "",
      nowday:"",
      nowWeek:"",
    };
  },
  created() {
    this.nowTimes();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      this.nowTime =  hh +
        ":" +
        mm +
        ":" +
        ss ;
      this.nowWeek =         getWeek;
      this.nowday =
        year +
        "-" +
        month +
        "-" +
        date 
        
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.time {
  // position: absolute;
  font-weight: 400;
  font-size: 15px;
  
  text-align: right;
  line-height: 1;

  // width: 400px;
 
  align-items: center;
}
.notime{
  // font-size: 34px;
}
.line{
  width: 1px;
  margin: 0 20px;
border-radius: 10px;
height: 30px;
border: 1px solid #3573D1;
}
</style>
